export const BASE_URL = '/organizations';

export const INFO_URL_PATH = 'info';
export const SETTINGS_HOME_URL_PATH = INFO_URL_PATH;

export const ADMIN_ORGANIZATIONS_BASE_URL = '/admin/organizations';
export const ADMIN_PERMISSIONS_BASE_URL = '/admin/staff_permissions';

export const EVENT_IMAGE_PLACEHOLDER_URL =
    'https://cdn.evbstatic.com/s3-build/perm_001/5287e3/django/images/pages/organizations/no-event-image-placeholder-2x.png';

//google analytics
export const ORGANIZATION_PROFILE_CATEGORY = 'update-profile';
export const ORGANIZATION_SETTINGS_DROPDOWN_CLICKED =
    'OrganizationSettingsDropdownClicked';
